export const Constants = {
  videoFormats: ['mp4', 'mov', 'webm', 'm4v', 'mpg', 'avi', 'mpeg'],
  learnMoreUrl: 'https://invideo.io/make/online-video-editor',
};

export const BannerMode = { Webinar: 'webinar', Normal: 'normal' } as const;
export type BannerMode = (typeof BannerMode)[keyof typeof BannerMode];

// Single switch for the top banner. Flip to BannerMode.Normal when a webinar
// campaign ends → BannerSlot renders StudioBanner instead of the webinar banner.
export const BANNER_MODE: BannerMode = BannerMode.Webinar;
